import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import {
  EvaluationGroup,
  TranslatableEnumValue,
} from "@rumble-it/common-lib/types/models/EvaluationGroup.interface";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";
import { formatTranslatableEnumList } from "../helpers/formatTranslatableEnumList";

export const evaluationGroupColumns: TableColumnsType<EvaluationGroup> = [
  {
    title: "Naam",
    dataIndex: "name",
    key: "name",
    render: (text: string, record: EvaluationGroup) => (
      <Link to={`/evaluation-groups/${record.id}`}>{text}</Link>
    ),
  },
  {
    title: "Input types",
    dataIndex: "inputTypes",
    key: "inputTypes",
    render: (inputTypes: TranslatableEnumValue[]) =>
      formatTranslatableEnumList(inputTypes),
  },
  {
    title: "Output types",
    dataIndex: "outputTypes",
    key: "outputTypes",
    render: (outputTypes: TranslatableEnumValue[]) =>
      formatTranslatableEnumList(outputTypes),
  },
  {
    title: "Rulesets",
    dataIndex: "ruleSetCount",
    key: "ruleSetCount",
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: unknown, record: EvaluationGroup) => (
      <Link to={`/evaluation-groups/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
